import { MonitoringGeneric, NewRelicProvider } from './monitoring-providers';

const monitoringProvider = new NewRelicProvider();
const monitoringInstance = new MonitoringGeneric(monitoringProvider, __APP_VERSION__);

export default monitoringInstance;
